import {firebase} from '../config/fbconfig';
 class LogMeout {
    static Logout(){
      return new Promise((resolve, reject)=>{
        firebase.auth().signOut().then(function() {
          resolve()
        }, function(error) {
          reject(error)
        });
      })
        
    }
}
export default LogMeout